import React from "react";
import * as _ from 'lodash';

import * as Misc from "./../../../misc";
import MessageBoxButton from './messageBoxButton';

export default (props) => {
    props = _.merge(props.state, props);
    const bClass = props.error ? 'message-red-lable' : 'message-blue-lable';
    const hClass = props.error ? 'message-error-message-title' : 'message-system-message-title';
    const messageClass = props.error ? 'message-system-text-red' : 'message-system-text-blue';
    let buttonsElements = [];
    if (props.buttons) {
      buttonsElements = props.buttons.map(function (b) {
        return (<MessageBoxButton button={b} key={b.text} error={props.error}/>);
      });
    } else {
      if (!props.showLoading) {
        buttonsElements.push((<div className={"message-" + (props.error ? 'error' : 'system') + "-dismiss-button"}
                                   onClick={(e) => Misc.ignore(e, () => props.click())} key="btnOk">
          {props.buttonText || 'OK'}
        </div>));
      }
    }

    const buttonClass = {
      marginLeft: '0px',
      backgroundImage: 'url(content/Views/quickquote-v3/images/icons/loading-spinner-' + (props.error ? 'red' : 'blue') + '.svg)'
    };

    return (
      <div className="full-screen-wrapper">
        <div className="message-window-base">
          <div className={hClass}>System Message</div>
          <div className={bClass}/>
          <div className={"message-system-text " + messageClass}>
            <p dangerouslySetInnerHTML={{__html: props.message}}/>
            {props.showLoading
              ?
              <div>
                <br />
                <br />
                <div className="button-spinner" style={buttonClass}> </div>
                  {props.loadingText}
              </div>
                : null}
          </div>
          <div className={"message-system-dismiss-button-wrapper message-system-dismiss-button-setting " + props.buttonClass}>
            {buttonsElements}
          </div>
        </div>
      </div>
    );
};




// WEBPACK FOOTER //
// ./src/components/common/messageBox/messageBox.js